import { Component, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone: false,
  selector: 'irb-refresh-scheduled-dialog',
  templateUrl: './refresh-scheduled-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class RefreshScheduledDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<RefreshScheduledDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public mdd: any) { }

  ngOnInit(): void {
    this.refreshSchdRebalance = this.mdd.refreshContinueFunction;
  }

  refreshSchdRebalance(){  
    if(this.mdd.refreshContinueFunction){
      this.mdd.refreshContinueFunction();
    }
  }
}
